import CheckBox from "@/common/components/CheckBoxPaymentMethod/CheckBoxPaymentMethod";
import { CartContext } from "@/setup/cartProvider";
import { Col, Grid, Text } from "@mantine/core";
import React, { useContext, useEffect, useState } from "react";

export default function PaymentMethod() {
  return (
    <Grid.Col
      sx={{
        margin: 0,
        borderRadius: "0.5rem",
      }}
    >
      <Text sx={{ marginBottom: 10 }}>Phương thức thanh toán</Text>
      <CheckBox keyItem="_id" defaultCheck />
    </Grid.Col>
  );
}
